export const HEALTH_STATUS = {
  Danger: 1,
  Warning: 2,
  Good: 3
};

export const STATS_SORTING = {
  Health: 'HEALTH',
  Custom: 'CUSTOM'
};

export const BP_HEALTH_THRESHOLDS = {
  defaultName: 'Default',
  customName: 'Custom'
};
